import React from 'react'
import './Structure.css'

function Structure() {
  return (
    <div className='container'>
         <div className='structure'>
                <div className='box-2'>
                    <h3>СТРУКТУРА</h3>
                    <div>
                      <h4>Председател на ИС:</h4>
                      <p>Тодор Савов Савов</p>
                    </div>
                    <div>
                      <h4>Главен Секретар:</h4>
                      <p>Стефан Николаев Попов</p>
                    </div>
                   
                    <div>
                      <h4>Контролен Съвет в състав:</h4>
                      <p>Недялко Бойчев Петков</p>
                      <p>Атанас Маринов Бъчваров</p>
                      <p>Недялко Радев Костадинов  </p>
                    </div>

                    <div>
                      <h4>Членове:</h4>
                      <p>Антон Митков Тончев</p>
                      <p>Владимир Георгиев Димитров</p>
                      <p>Ангел Панчев Ангелов </p>
                      <p>Нергюл Рафет Юзеир</p>
                      <p>Светлена Стоянова Христова</p>
                    </div>
                </div>
            </div>
    </div>
  )
}

export default Structure